import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { User } from '../_models';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { UserInfo } from '../_models/user-info';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  updateUserData = new BehaviorSubject<UserInfo>(null);

  constructor(
    private http: HttpClient
  ) { }

  addUser(user: User){
    return this.http.post(`${environment.apiUrl}/api/users`,user);
  }

  getAllUsers(){
    return this.http.get<User[]>(`${environment.apiUrl}/api/users`)
    .pipe(map(responseData =>{
      return responseData;
    })
    )
  }

  getAllDeletedUsers(){
    return this.http.get<User[]>(`${environment.apiUrl}/api/users/deleted`)
    .pipe(map(responseData =>{
      return responseData;
    })
    )
  }

  deleteUser(userId: number){
    return this.http.delete(`${environment.apiUrl}/api/users/${userId}`);
  }

  updateUser(userId: number, user: User){
    return this.http.patch<User>(`${environment.apiUrl}/api/users/${userId}`,user);
  }
}
